import { render, staticRenderFns } from "./MultiplicationAndDivisionMathMagic.vue?vue&type=template&id=32287945&scoped=true&lang=pug&"
import script from "./MultiplicationAndDivisionMathMagic.vue?vue&type=script&lang=js&"
export * from "./MultiplicationAndDivisionMathMagic.vue?vue&type=script&lang=js&"
import style0 from "./MultiplicationAndDivisionMathMagic.vue?vue&type=style&index=0&id=32287945&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32287945",
  null
  
)

export default component.exports